$(function () {
    var forms = $('.js-form');
    if (forms.length) {
        forms.map(function (i, item) {
            var form = new TurboForm(item, {
                showErrorAfterInput: true,
                fieldLineClass: 'form__field'
            });
            form.showSuccessMessage = function (message) {
                var container = this.form.closest('.popup__container');
                container.style.display = 'none';
                var div = document.createElement('div');
                div.innerHTML = message;
                div.style.textAlign = 'center';
                container.nextElementSibling.querySelector('.popup__content').appendChild(div);
                container.nextElementSibling.style.display = '';
            };
        })
    }


    var searchContainer = $('#search');
    if (searchContainer.length) {
        var searchInput = searchContainer.find('.js-search-input'),
            resultContainer = searchContainer.find('.js-search-result'),
            timeout = null,
            delay = 500,
            getData = function () {
                $.getJSON('/search/sagest/', {
                    q: searchInput.val()
                }, function (data) {
                    if (data.success) {
                        resultContainer.html(data.html);
                        resultContainer.removeClass('h-invisible');
                    } else {
                        resultContainer.addClass('h-invisible');
                    }
                })
            };

        searchInput.on('change input', function (e) {
            clearTimeout(timeout);
            timeout = setTimeout(getData, delay);
        });
    }
});
